
<template>
  <div class="singapore-view">
    <h1>Singapore</h1>
  </div>
</template>

<script>
export default {
  name: "SingaporeView",
};
</script>
